<ng-container *ngFor="let ind of airlinePreferencesLogIndexes">
  <div class="mb-2" *ngIf="logs[ind] as log">
    <ag-shr-change-log-detail-by-type
      [keysConfig]="airlinePreferencesLookup"
      [changeLogs]="Array.isArray(log) ? log[0] : log"
    >
    </ag-shr-change-log-detail-by-type>
  </div>
</ng-container>
